function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M73.03 31H46.867C38.135 31 31 38.135 31 46.868V73.03c0 8.733 7.135 15.868 15.868 15.868H73.03c8.734 0 15.868-7.135 15.868-15.868V46.87C88.897 38.095 81.801 31 73.03 31zm12.475 41.99c0 6.862-5.575 12.437-12.437 12.437h-26.16c-6.863 0-12.438-5.575-12.438-12.437V46.83c0-6.863 5.575-12.438 12.437-12.438h26.161c6.862 0 12.437 5.575 12.437 12.437V72.99z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.968 44.061c-8.772 0-15.868 7.135-15.868 15.868 0 8.772 7.135 15.868 15.868 15.868 8.773 0 15.868-7.135 15.868-15.868 0-8.772-7.134-15.868-15.868-15.868zm0 28.305c-6.862 0-12.476-5.575-12.476-12.476 0-6.862 5.575-12.476 12.476-12.476 6.862 0 12.477 5.575 12.477 12.476-.04 6.901-5.615 12.476-12.477 12.476zM76.772 38.291c-2.65 0-4.834 2.183-4.834 4.835 0 2.65 2.183 4.834 4.834 4.834 2.652 0 4.835-2.183 4.835-4.834a4.809 4.809 0 00-4.835-4.835zm0 6.2c-.78 0-1.403-.625-1.403-1.404 0-.78.624-1.404 1.403-1.404.78 0 1.404.624 1.404 1.404 0 .78-.624 1.403-1.404 1.403z",
  fill: "#384B51"
});

function SvgInstagram(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgInstagram;